import Link from "next/link";
import React from "react";

const Button = (props: any) => {
  return <Link className={`${props.btnClass} btn`} href={`${props?.btnLink}`} target={props?.linkOpenState ? "_blank" : ""}>{props.btnText}</Link>;
  // return <button className={`${props.btnClass} btn`}>{props.btnText}</button>;
};

export default Button;
